import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { SplashScreen } from 'src/components/loading-screen';
import AITerms from 'src/LandingUi/registerUi/AITerms';
import PolicyLayout from '../../LandingUi/registerUi/PolicyLayout';
import TermsOfService from '../../LandingUi/registerUi/TermsOfService';
import PrivacyPolicy from '../../LandingUi/registerUi/PrivacyPolicy';

export const policyRoutes = [
    {
        path: '/',
        element: (
            <Suspense fallback={<SplashScreen />}>
                <PolicyLayout />
            </Suspense>
        ),
        children: [
            {
                path: 'terms-of-service',
                element: <TermsOfService />,
            },
            {
                path: 'privacy-policy',
                element: <PrivacyPolicy />,
            },
            {
                path: 'ai-terms',
                element: <AITerms />,
            },
        ],
    },
];